import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/dc-logo.png';
import Profile from './auth/Profile';

const Header: React.FC = () => {
    return (
        <header className="bg-blue-600 text-white p-4">
            <div className="container mx-auto">
                <nav className="flex items-center justify-between">
                    <Link to="/" className="text-3xl font-bold">
                        <img src={logo} alt="The Dream Centre Logo" style={{ height: "35px" }} className="mr-4 float-left" />
                        DC Transcriber
                    </Link>
                    <div className="flex items-center">
                        <Link to="/" className="mr-6 hover:text-blue-300 text-lg">
                            Upload Audio
                        </Link>
                        <Profile />
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;